import { FC, ReactElement } from 'react';
import { Chip, Skeleton } from '@hopskipdrive/react-components';

interface LabelChipProps {
  label: string;
  icon?: ReactElement;
  textColor: string;
  bgColor: string;
  isFetching: boolean;
  border?: string;
  onClick?: () => void;
}

export const LabelChip: FC<LabelChipProps> = ({ isFetching, label, icon, textColor, bgColor, border, onClick }) => {
  return isFetching ? (
    <Skeleton variant="rectangular" width={120} height={35} />
  ) : (
    <Chip
      type="square"
      label={label}
      icon={icon}
      sx={{
        color: textColor,
        background: bgColor,
        minHeight: '35px',
        border: border,
        padding: '2px 6px',
        gap: '6px',
        '& .MuiChip-label': {
          padding: 0,
        },
      }}
      onClick={onClick}
    />
  );
};
